var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formattedTime)?_c('div',{staticClass:"vaimo-booxi-life-time"},[_c('div',{staticClass:"vaimo-booxi-life-time__wrapper"},[_c('div',{staticClass:"icon"},[_c('VaimoIcon',{attrs:{"icon":"sand_clocks","size":12}})],1),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("\n      "+_vm._s(_vm.$t('Booked until {time}', {
          time: _vm.formattedTime
        }))+"\n    ")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }